import {css} from "styled-components"

import primaryCss from "./primaryButtonCss"
import tertiaryCss from "./tertiaryButtonCss"
import destructiveCss from "./destructiveButtonCss"
import {largeCss, smallCss} from "./sizesCss"
import {spacingCss, SpacingProps} from "../../global/css"
import {h5} from "../../Typography/Heading/styles"

export interface ButtonCssProps extends SpacingProps {
  primary?: boolean
  tertiary?: boolean
  destructive?: boolean
  cta?: boolean
  full?: boolean
  large?: boolean
  small?: boolean
  inverted?: boolean
  mobileFull?: boolean
}

// Default - Secondary - Outlined
const ButtonCss = css<ButtonCssProps>`
  ${({theme, full, inverted, large, small, primary, tertiary, cta, destructive, mobileFull}) => css`
    transition:
      all 0.25s ease,
      padding 0s;
    box-sizing: border-box;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    cursor: pointer;
    position: relative;

    border-radius: 27px;
    color: ${theme.colors.primary2};
    padding: ${theme.spacing.oneAndHalf} ${theme.spacing.four};
    background-color: transparent;
    border: 2px solid ${theme.colors.primary2};

    path {
      transition: fill 0.25s ease;
      fill: ${theme.colors.primary2};
      ${inverted && `fill: ${theme.colors.utility.white};`}
    }

    ${theme.mediaQueries.maxWidthMedia.tablet`
      ${mobileFull && "width: 100%;"}
    `}

    ${theme.mediaQueries.minWidthMedia.tablet`
      &:hover, &:active, &:focus {

          color: ${theme.colors.utility.white};
          background-color: ${theme.colors.primary2};
          text-decoration: none;

          path {
            fill: ${theme.colors.utility.white};
          }
        }
    `}

    &:disabled, &.disabled {
      cursor: not-allowed;
      color: ${theme.colors.primary2_100};
      border: 2px solid ${theme.colors.primary2_100};
      background-color: transparent;
      path {
        fill: ${theme.colors.primary2_100};
        ${inverted &&
        css`
          fill: ${theme.colors.primary2_200};
        `}
      }
      ${inverted &&
      css`
        color: ${theme.colors.primary2_200};
        border: 2px solid ${theme.colors.primary2_200};
        background-color: transparent;
      `}
    }

    ${inverted &&
    css`
      color: ${theme.colors.utility.white};
      border: 2px solid ${theme.colors.utility.white};

      ${theme.mediaQueries.minWidthMedia.tablet`
          &:hover,
          &:active,
          &:focus {
            color: ${theme.colors.primary2};
            background-color: ${theme.colors.utility.white};

            path {
              fill: ${theme.colors.primary2};
            }
          }
        `}
    `}

    ${h5};
    ${large && largeCss}
    ${small && smallCss}

    ${primary && primaryCss}
    ${(tertiary || cta) && tertiaryCss}
    ${destructive && destructiveCss}

    ${full && "width: 100%;"}

    path[fill="none"] {
      fill: none;
    }

    .loader {
      position: absolute;
      margin: 0 0 0 -4px;
      &:before {
        left: -12px;
      }
      &:after {
        left: 12px;
      }
    }
    .loader,
    .loader:before,
    .loader:after {
      width: ${theme.spacing.one};
      height: ${theme.spacing.one};
      border-radius: ${theme.spacing.one};
    }
  `}
  ${spacingCss}
`

export default ButtonCss
